<template>
  <div class="component-cropper">
    <el-button-group style="margin-bottom:10px;width:100%">
      <el-button @click="clickChooise" type="primary" style="width:50%">选择图片</el-button>
      <el-button @click="clickCut" type="primary" :disabled="!previewImg" style="width:50%">裁剪</el-button>
    </el-button-group>
    <div class="avatar-uploader component-upload-img" ref="box">
      <input @change="inputChange" hidden type="file" ref="input" accept="image/png, image/jpeg">
      <!--本地图片，仅供预览-->
      <img v-if="previewImg" :src="previewImg" class="avatar" ref="preview">
      <!--服务器上的图片-->
      <img v-else-if="value" :src="window.CONFIG.IMG_SERVER + value" class="avatar" minHeight="150px"/>
      <!--没图片-->
      <i class="el-icon-picture avatar-uploader-icon" v-else></i>
    </div>
  </div>
</template>
<style scoped>
  img{
    max-width:100%;
  }
</style>
<style lang="scss" scoped>
  @import "cropper.theme";
  .component-cropper{
    @import "./libs/cropper.min.css";
    .avatar-uploader {
      width: 100%;
      box-sizing:border-box;
      min-height:200px;
      margin: 0 auto;
      margin-bottom: 10px;
      border: 1px solid $cropper-border-color;
      position: relative;
      overflow: hidden;
      display:flex;
      justify-content:center;
      align-items:center;
    }
    .avatar-uploader .el-upload:hover {
      border-color: $cropper-border-hover-color;
    }
    .avatar-uploader-icon {
      font-size: 60px;
      color: $cropper-icon-color;
      width:100%;
      text-align: center;
      position: relative;
    }
    .avatar {
      width: 100%;
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/cropper/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/cropper/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/cropper/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-cropper')
  export default {
    name: 'base-cropper', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-cropper': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>